import {
  Button,
  useDisclosure,
  VStack,
  Flex,
  Icon,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Inputs } from '../../../../types/Enums';
import { NaceCode } from '../../../../types/CompanyScanTypes';
import { getFlowsDataTestId } from '../../../../utils/testUtils';
import NaceCodeModal from './NaceCodeModal';
import NaceCodeTable from './NaceCodeTable';

interface Props {
  name?: string;
  value: NaceCode[];
  onChange: (naceCodes: NaceCode[]) => void;
  isDisabled?: boolean;
}

const NaceCodeInput: React.FC<React.PropsWithChildren<Props>> = ({
  name,
  value = [],
  onChange,
  isDisabled,
}) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleOnRemove = (index: number) => {
    onChange(value.filter((_, _index) => _index !== index));
  };

  return (
    <VStack align="stretch" spacing="4">
      {isOpen && (
        <NaceCodeModal
          value={value}
          onChange={onChange}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
      <NaceCodeTable
        naceCodes={value}
        onRemove={handleOnRemove}
        isDisabled={isDisabled}
      />
      <Flex justify="flex-end">
        <Button
          onClick={onOpen}
          leftIcon={<Icon name="GeneralActionsAdd" />}
          data-test-id={getFlowsDataTestId(
            Inputs.NACE_CODE,
            name || '',
            'ADD-BUTTON',
          )}
          isDisabled={isDisabled}
        >
          {t('FLOWS_COMPANY-SCAN_NACE-INPUT_ADD-NACE')}
        </Button>
      </Flex>
    </VStack>
  );
};

export default NaceCodeInput;
